// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_roads_plus_label: MapboxStyleLayer[] = [
  {
    minzoom: 8,
    layout: {
      'text-size': ['interpolate', ['linear'], ['zoom'], 7, 4, 9, 9],
      'icon-text-fit': 'width',
      'icon-image': 'rectangle-yellow-3',
      'icon-rotation-alignment': 'viewport',
      'text-transform': 'uppercase',
      'symbol-spacing': 700,
      'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
      'symbol-placement': 'line',
      'text-rotation-alignment': 'viewport',
      'icon-size': 1.2,
      'text-field': ['to-string', ['get', 'name_ref']],
      'text-letter-spacing': -0.02,
      'icon-padding': 6,
    },
    filter: [
      'all',
      [
        'match',
        ['get', 'road'],
        ['primary', 'primary_link', 'secondary', 'secondary_link'],
        true,
        false,
      ],
      ['has', 'name_ref'],
    ],
    type: 'symbol',
    id: 'sign_label-roads',
    paint: {
      'text-color': '#595959',
    },
  },
]
